import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IssueManagementService {

  constructor(private http: HttpClient) { }

  getScenarios(baseUrl: string, taxYear: string): Observable<any> {
    const url = `${baseUrl}/getScenarios?tax_year=${taxYear}&jcd_key=250`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getAllIssues(baseUrl: string): Observable<any> {
    const url = `${baseUrl}/getAllIssues`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getIssueDetails(baseUrl: string, issueId: string): Observable<any> {
    const url = `${baseUrl}/getIssueData/${issueId}`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getTYScenarios(baseUrl: string): Observable<any> {
    const url = `${baseUrl}/getTYScenarios`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getStdDesc(baseUrl: string): Observable<any> {
    const url = `${baseUrl}/getStdDesc`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  getAdjustmentTypes(baseUrl: string, taxYear: string): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=ibz5e4&tax_year=${taxYear}&jcd_key=250`;
    return this.http.get<any>(url, { withCredentials: true });
  }

  saveIssue(baseUrl: string, issueParams: string): Observable<any> {
    const url = `${baseUrl}/saveIssue`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post<any>(url, issueParams, { headers, withCredentials: true });
  }

  updateIssue(baseUrl: string, issueParams: string): Observable<any> {
    const url = `${baseUrl}/updateIssue`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    return this.http.post<any>(url, issueParams, { headers, withCredentials: true });
  }
}

